import { Link } from "react-router-dom";
import { MapPin, Phone, EnvelopeSimple, ArrowUpRight } from "@phosphor-icons/react";
import { NAV_LINKS, LEGAL_LINKS, CONTACT } from "@/lib/site";

export const Footer = () => {
  return (
    <footer
      data-testid="site-footer"
      className="relative z-10 bg-ink text-paper"
    >
      <div className="mx-auto max-w-[1400px] px-6 md:px-12 pt-20 md:pt-28 pb-10">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-12 lg:gap-8">
          <div className="lg:col-span-5">
            <p className="text-xs uppercase tracking-[0.2em] font-bold text-paper/50">
              Interlaced Social LLC
            </p>
            <h2 className="font-serif text-5xl md:text-6xl mt-5 leading-[0.95]">
              Double<span className="italic text-oxblood">list</span>.
            </h2>
            <p className="mt-6 max-w-md text-paper/60 leading-relaxed">
              An adults-only social networking and personal classifieds platform
              built on discretion, consent, and trust. Strictly 18+.
            </p>
          </div>

          <div className="lg:col-span-3 lg:col-start-7">
            <p className="text-xs uppercase tracking-[0.2em] font-bold text-paper/50 mb-6">
              Explore
            </p>
            <ul className="space-y-3">
              {NAV_LINKS.map((l) => (
                <li key={l.path}>
                  <Link
                    to={l.path}
                    data-testid={`footer-link-${l.label.toLowerCase().replace(/\s+/g, "-")}`}
                    className="link-underline text-paper/80 hover:text-paper transition-colors"
                  >
                    {l.label}
                  </Link>
                </li>
              ))}
              {LEGAL_LINKS.map((l) => (
                <li key={l.path}>
                  <Link
                    to={l.path}
                    data-testid={`footer-link-${l.label.toLowerCase().replace(/\s+/g, "-")}`}
                    className="link-underline text-paper/80 hover:text-paper transition-colors"
                  >
                    {l.label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          <div className="lg:col-span-3">
            <p className="text-xs uppercase tracking-[0.2em] font-bold text-paper/50 mb-6">
              Contact
            </p>
            <ul className="space-y-5 text-paper/80">
              <li className="flex gap-3">
                <MapPin size={20} weight="light" className="shrink-0 mt-0.5 text-oxblood" />
                <span className="leading-relaxed">{CONTACT.address}</span>
              </li>
              <li>
                <a
                  href={`tel:${CONTACT.phone.replace(/\s/g, "")}`}
                  data-testid="footer-phone"
                  className="flex gap-3 hover:text-paper transition-colors"
                >
                  <Phone size={20} weight="light" className="shrink-0 text-oxblood" />
                  {CONTACT.phone}
                </a>
              </li>
              <li>
                <a
                  href={`mailto:${CONTACT.email}`}
                  data-testid="footer-email"
                  className="flex gap-3 hover:text-paper transition-colors break-all"
                >
                  <EnvelopeSimple size={20} weight="light" className="shrink-0 text-oxblood" />
                  {CONTACT.email}
                </a>
              </li>
            </ul>
          </div>
        </div>

        <div className="mt-16 pt-8 border-t border-paper/15 flex flex-col md:flex-row justify-between gap-4 text-sm text-paper/50">
          <p>© {new Date().getFullYear()} Interlaced Social LLC. All rights reserved.</p>
          <p className="flex items-center gap-2">
            Adults only — 18+ <ArrowUpRight size={14} />
          </p>
        </div>
      </div>
    </footer>
  );
};
